import React from "react";
import { Modal, Button, ModalHeader, ModalBody } from "react-bootstrap";

interface SuccessModalProps {
  show: boolean;
  handleClose: () => void;
  title?: string;
  message?: string;
  buttonLabel?: string;
  hideButton?: boolean;
}

export const SuccessModal = ({
  show,
  handleClose,
  title = 'Success!',
  message = 'Operation completed successfully.',
  buttonLabel = 'OK',
  hideButton = false,
}: SuccessModalProps) => {
  return (
    <React.Fragment>
      <Modal show={show} onHide={handleClose} id="successModal" className="fade zoomIn" dialogClassName="modal-dialog-centered">
        <ModalHeader closeButton></ModalHeader>
        <ModalBody className="p-md-5">
          <div className="text-center">
            <div className="text-success">
              <i className="bi bi-check-circle display-5"></i>
            </div>
            <div className="mt-4">
              <h4>{title}</h4>
              <p className="text-muted mx-4 mb-0">{message}</p>
            </div>
          </div>
          {!hideButton && (
            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
              <Button 
                type="button" 
                variant="primary" 
                className="btn w-sm" 
                onClick={handleClose}
              >
                {buttonLabel}
              </Button>
            </div>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
